"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const Menu_1 = __importDefault(require("@mui/icons-material/Menu"));
const material_1 = require("@mui/material");
const react_query_1 = require("@tanstack/react-query");
const lodash_1 = __importDefault(require("lodash"));
const react_1 = require("react");
const react_router_1 = require("react-router");
const appConstants_1 = require("../../../../constants/appConstants");
const teamQuery_1 = require("../../../../queries/teamQuery");
const userQuery_1 = require("../../../../queries/userQuery");
const userSelectors_1 = require("../../../../selectors/userSelectors");
const zustandStore_1 = require("../../../../zustandStore");
const headerNavigation_1 = __importDefault(require("../../../organisms/header/headerNavigation"));
function getTabHeader({ userTabs, pathName }) {
    const tabHeaderMap = userTabs.reduce((acc, tab) => {
        return { ...acc, [tab.link]: tab };
    }, {});
    const matchingPath = Object.keys(tabHeaderMap).find(path => path.includes(pathName));
    return matchingPath ? tabHeaderMap[matchingPath]?.id : '';
}
const WalletHeader = () => {
    const initialData = (0, react_router_1.useLoaderData)();
    const { teamFilter, memberFilter, headerName, activeHeaderTab, setActiveHeaderTab, resetWalletFilters, setTeamFilter, setMemberFilter, openSideMenuOnMobileView, } = (0, zustandStore_1.useZustand)(state => ({
        teamFilter: state.wallet.teamFilter,
        memberFilter: state.wallet.memberFilter,
        headerName: state.header.headerName,
        activeHeaderTab: state.header.activeHeaderTab,
        setActiveHeaderTab: state.setActiveHeaderTab,
        resetWalletFilters: state.resetWalletFilters,
        setTeamFilter: state.setTeamFilter,
        setMemberFilter: state.setMemberFilter,
        openSideMenuOnMobileView: state.openSideMenuOnMobileView,
    }));
    const { data: userData } = (0, react_query_1.useQuery)({
        ...userQuery_1.userQuery,
        initialData: initialData.userData,
    });
    const { data: teamId } = (0, react_query_1.useQuery)({
        ...(0, teamQuery_1.selectedTeamIdQuery)('selectedTeamID'),
        initialData: initialData.teamId,
    });
    const userSelectedTeamId = teamId && teamId.length > 0 ? teamId?.[0] : '';
    const userRole = (0, userSelectors_1.isCompanyOrSupportAdmin)(lodash_1.default.get(userData, 'roles', []))
        ? appConstants_1.overviewConstants.COMPANY_ADMIN
        : userData?.roles.find(role => role.securityGroupId === userSelectedTeamId)?.roleId || '';
    const userTabs = appConstants_1.walletHeaderTabs[userRole || ''] || [];
    const currentTabHeader = getTabHeader({ userTabs, pathName: globalThis.location.pathname });
    (0, react_1.useEffect)(() => {
        setTeamFilter(teamFilter);
    }, [teamFilter]);
    (0, react_1.useEffect)(() => {
        setMemberFilter(memberFilter);
    }, [memberFilter]);
    (0, react_1.useEffect)(() => {
        if (!currentTabHeader) {
            return;
        }
        setActiveHeaderTab(currentTabHeader);
        resetWalletFilters();
    }, [activeHeaderTab, currentTabHeader]);
    return ((0, jsx_runtime_1.jsxs)(material_1.Stack, { className: "main-header", "data-testid": "main-header", style: { zIndex: 0 }, children: [(0, jsx_runtime_1.jsxs)(material_1.AppBar, { "ts-variant": "main-header", "data-testid": "main-header", style: { zIndex: 0 }, children: [(0, jsx_runtime_1.jsx)(material_1.Button, { "data-testid": "hamburger-btn", "ts-variant": "hamburger", onClick: () => openSideMenuOnMobileView(true), children: (0, jsx_runtime_1.jsx)(Menu_1.default, { style: { stroke: 'black' } }) }), (0, jsx_runtime_1.jsx)(material_1.Tooltip, { title: headerName, children: (0, jsx_runtime_1.jsx)(material_1.Typography, { "data-testid": "header-overview-title", "ts-variant": "header", children: headerName }) })] }), (0, jsx_runtime_1.jsx)(headerNavigation_1.default, { tabs: userTabs, end: false })] }));
};
exports.default = WalletHeader;
